import React from 'react';
import styles from './About.module.scss';

const About = () => {
	return (
		<section id='about' className={styles.wrapper}>
			<h2 className={styles.title}>Про мене</h2>
			<h4 className={styles.text}>
				Привіт! Я — фронтенд розробниця, яка створює сучасні, адаптивні вебсайти.
			</h4>
			<p className={styles.status}>
				Мій девіз по життю -
				<blockquote>
					"Страх — перший неминучий ворог, котрого людина мусить перемогти на шляху до
					знання."{' '}
				</blockquote>
			</p>
			<div className={styles.history}>
				<p>
					Моя історія про те, як я кардинально змінила своє життя, перейшовши з
					банківської та юридичної сфери в абсолютно далеку від неї -- IT-сферу{' '}
				</p>
				<p>
					Тривалий час працювала в банку, де обіймала посаду{' '}
					<strong>заступника директора </strong>
					відділення, але мені було цікаво, як влаштовані ті всі програми зсередини, як
					вони створюються та чому можуть час від часу "зависати", "не працювати" або
					"сервер тимчасово недоступний". Навчання стало не просто новим етапом, а
					внутрішньою потребою до розвитку.
				</p>
				<p>
					Працюючи на керівній посаді, я <strong>набула сильні навички</strong>{' '}
					управління, комунікації та роботи з клієнтами. Цей досвід допомагає мені
					працювати структуровано, відповідально та ефективно в команді
				</p>
				<p>
					<em>Склала власний навчальний план</em> та опанувала JavaScript, React, Vue 3,
					HTML, CSS, Git, Angular
				</p>
				<p>Виконала 14 практичних проєктів та на стадії розробки ще декілька.</p>
				<p>
					Вивчала матеріали: MDN, Oxford Home Study Centre, Epum Campus, freeCodeCamp,
					YouTube, різну документацію, "дружу" з ШІ та вмію задавати йому правильні
					питання, вважаю, що ШІ створений допомогти швидше підібрати різні варіанти
					вирішення того чи іншого питання та знайти оптимальний. <br /> Шукаю компанію,
					яка цінує прагнення, потенціал і бажання вчитися.
				</p>
				<ul className={styles.tekh_skills}>
					<strong>Технічні навички:</strong>
					<li>Мови: JavaScript (ES6+), TypeScript (базово)</li>
					<li>Фреймворки та бібліотеки: React.js, Redux Toolkit, Vue 3, Angular</li>
					<li>Верстка: HTML5, CSS3 (SASS, Tailwind)</li>
					<li>Робота з API: REST API, Axios</li>
					<li>Інструменти: Git, GitHub, Webpack, Vite</li>
					<li>Бази даних: Firebase, MongoDB(базово) </li>
					<li>Методології: Agile, Scrum - базово, JIRA.</li>
					<li>Постійна практика та вдосконалення навичок, робота з пет-проектами</li>
				</ul>
				<ul className={styles.soft_skills}>
					<strong>Мої soft skills:</strong>
					<li>
						комунікативність - готова працювати в великій команді та ефективно
						взаємодіяти
					</li>
					<li>
						вміння розуміти потреби користувачів та готовність вирішувати складні кейси,
					</li>
					<li>ефективне планування роботи,</li>
					<li>
						розв'язання проблем, оптимізація процесів, слідкування за виконанням КРІ,
					</li>
					<li>аналітичне мислення,</li>
					<li>готова швидко вчитися та розвиватися в IT</li>
					<li>
						оптимістка - вірю, що зміни - це шанс, а навчання - ключ до нових
						можливостей
					</li>
					<li>ну і як же ми без дедлайнів? на коли треба?))</li>
				</ul>
			</div>
		</section>
	);
};

export default About;
